import Joi from "joi";

export default Joi.object({
	app_id: Joi.string().required(),
	app_secret: Joi.string().required()
});
